export default __webpack_public_path__ + "static/media/after-effects-logo.24de2264.svg";